<template>
  <span
    class="icon info-tooltip"
    :class="{
      'has-tooltip-multiline': multilined != undefined,
      'has-tooltip-top': bottom == undefined && right == undefined,
      'has-tooltip-bottom': bottom != undefined,
      'has-tooltip-right': right != undefined }"
    :data-tooltip="tooltipText">
    <awesome-icon icon="question-circle" aria-hidden="true" size="xs"/>
  </span>
</template>

<script>
export default {
  props: ["tooltipText", "multilined", "white", "bottom", "right"]
}
</script>

<style lang="scss" scoped>
.icon {
  font-size: 1rem;
}
</style>